export default __webpack_public_path__ + "static/13-5fcc601109d93dd27215611e4069338b.webp";